import styled from "styled-components";

import {
  ConflictErrorSeverity,
  DATA_E2E_KEY,
  IStyledAttributes,
} from "@ryde/shared";

import { CONFLICT_NAV_SEVERITY_COLORS } from "./conflicts-nav.constants";

export const ConflictsNavStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "conflict-nav",
})<{ $severity: ConflictErrorSeverity; $accentColor?: string }>`
  flex: 1;
  display: flex;

  .ConflictsNav-Title {
    color: ${({ $accentColor, $severity }) =>
      $accentColor ?? CONFLICT_NAV_SEVERITY_COLORS[$severity]};
  }

  .ConflictsNav-ConflictNumbers {
    margin-inline-start: auto;
    color: ${({ $accentColor, $severity }) =>
      $accentColor ?? CONFLICT_NAV_SEVERITY_COLORS[$severity]};
    font-weight: 700;
  }
`;
